module.exports = __webpack_public_path__ + "static/media/macModel.c3b7de81.png";